import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TopicAdd from '../topics/TopicAdd'
import List from '../topics/List'
import Intro5am from '../../typography/Intro5am'
import { deleteTopic, changeTopicContext } from '../../../actions/topics'

class Topics extends Component {
  constructor() {
    super()
    this.changeContextBound = this.changeContext.bind(this)
    this.deleteTopicBound = this.deleteTopic.bind(this)
  }
  render() {
    const { topics, dispatch, allowEdit } = this.props

    return (
      <div className="topics">
        {allowEdit && (
          <TopicAdd
            questId={this.props.questId}
            dispatch={dispatch}
            topicSearchResults={this.props.topicSearchResults}
            isSearching={this.props.isSearching}
          />
        )}
        {topics && topics.length > 0 && (
          <div id="questTopicList">
            <List
              topics={topics}
              hideActions={!allowEdit}
              dispatch={dispatch}
              lines={3}
              deleteTopic={this.deleteTopicBound}
              changeContext={this.changeContextBound}
            />
          </div>
        )}
        {!topics ||
          (topics.length === 0 && (
            <Intro5am style={{ margin: '44px auto', textAlign: 'center' }}>
              No topics are linked to this quest.
            </Intro5am>
          ))}
      </div>
    )
  }

  deleteTopic(topicId) {
    const { dispatch, questId } = this.props
    const confirmation = confirm(
      'Are you sure you want to remove this topic/standard link?'
    )
    if (confirmation) {
      dispatch(deleteTopic(questId, topicId))
    }
  }

  changeContext(topicId, context) {
    const { dispatch, questId } = this.props
    dispatch(changeTopicContext(questId, topicId, context))
  }
}

Topics.propTypes = {
  topics: PropTypes.array,
  dispatch: PropTypes.func.isRequired,
  topicSearchResults: PropTypes.array.isRequired,
  isSearching: PropTypes.bool.isRequired,
  questId: PropTypes.number.isRequired,
  allowEdit: PropTypes.bool.isRequired
}

export default Topics



// WEBPACK FOOTER //
// ./src/components/quest/section/Topics.js